import React, { useState } from 'react'
import '../Scss/Properties.scss'
import SortIcon from '@material-ui/icons/Sort';
import { Formik, Form, Field } from 'formik';
import InitialMap from '../Components/InitialMap'
import PropertyThumb from '../Components/PropertyThumb'
import {properties} from '../data.js'

const Properties = () => {

    const [advanced, setAdvanced] = useState(false)

    function showAdvanced(){
        setAdvanced(!advanced)
    }

    const propertyList = properties.map((property)=>
        <div className="col-lg-4 mt-4">
            <PropertyThumb property={property} />
        </div>
       
    )

    return(
        <div>
            <InitialMap  
                properties={properties}
            />
            <div className="advance-search">
                <Formik
                    initialValues={{
                        property_type: 'any',
                        price: { from: '', to: ''},
                        street: '',
                        zipcode: '',
                        city: '',
                        state: '',
                        bedrooms: '',
                        bathrooms: '',
                        kitchen: '',
                    }}

                    onSubmit={async(data,{setSubmitting}) => {
                        setSubmitting(true);
                        
                        //onsubmit function
                        

                        setSubmitting(false);
                    }}
                >
                    {({ isSubmitting, values }) => (
                        
                        <Form>
                            <div className="form-row p-3">
                                <div className="form-group col-lg-4">
                                    <label for="property_type">PROPERTY TYPE</label> 
                                    <Field 
                                        name='property_type'
                                        label="property_type"
                                        className="form-control"
                                        as='select'
                                    >
                                        <option value="any">Property Type</option>
                                        <option>House</option>
                                    </Field>
                                </div>
                                <div className="form-group col-lg-4">
                                    <label for="property_type">PRICE</label> 
                                    <div className="form-row">
                                        <Field 
                                            name='price.from'
                                            label="price"
                                            type="number"
                                            placeholder="From"
                                            className="form-control col"
                                            as='input'
                                        />
                                        <div className="col-0.5 text-center" style={{lineHeight:3}}>-</div> 
                                        <Field 
                                            name='price.to'
                                            label="price"
                                            type="number"
                                            placeholder="To"
                                            className="form-control col"
                                            as='input'
                                        />
                                    </div>
                                </div>
                                <div className="form-group col-lg-4">
                                    <label for="property_type">CITY</label> 
                                    <Field 
                                        name='City'
                                        label="city"
                                        type="input"
                                        placeholder="City"
                                        className="form-control"
                                        as='input'
                                    />
                                </div>
                                {
                                    advanced ?
                                        <>
                                            <div className="form-group col-lg-4">
                                                <label for="property_type">STREET</label> 
                                                <Field 
                                                    name='street'
                                                    type="input"
                                                    className="form-control"
                                                    placeholder="Street"
                                                    as='input'
                                                />
                                            </div>
                                            <div className="form-group col-lg-4">
                                                <label for="property_type">STATE</label> 
                                                <Field 
                                                    name='state'
                                                    type="input"
                                                    className="form-control"
                                                    placeholder="State"
                                                    as='input'
                                                />
                                            </div>
                                            <div className="form-group col-lg-4">
                                                <label for="property_type">ZIP CODE</label> 
                                                <Field 
                                                    name='zipcode'
                                                    type="input"
                                                    className="form-control"
                                                    placeholder="Zip Code"
                                                    as='input'
                                                />
                                            </div>
                                            <div className="form-group col-lg-4">
                                                <label for="property_type">BEDROOMS</label> 
                                                <Field 
                                                    name='bedrooms'
                                                    type="number"
                                                    className="form-control"
                                                    placeholder="Bedrooms"
                                                    as='input'
                                                />
                                            </div>
                                            <div className="form-group col-lg-4">
                                                <label for="property_type">BATHROOMS</label> 
                                                <Field 
                                                    name='bathrooms'
                                                    type="number"
                                                    placeholder="Bathrooms"
                                                    className="form-control"
                                                    as='input'
                                                />
                                            </div>
                                            <div className="form-group col-lg-4">
                                                <label for="property_type">KITCHEN</label> 
                                                <Field 
                                                    name='kitchen'
                                                    type="number"
                                                    placeholder="Kitchens"
                                                    className="form-control"
                                                    as='input'
                                                />
                                            </div>
                                        </>
                                    :
                                        <></>
                                }
                            </div>
                            <div className="text-center">
                                <button  className="btn btn-danger">CLEAR</button>
                                <button className="btn btn-theme ml-2" onClick={()=>showAdvanced()}>{advanced ? "HIDE" : "ADVANCED" }</button>
                            </div>
                            <div className="sort-properties mt-4">
                                <ul>
                                    <li><SortIcon />Sort by:</li>
                                    <li>NEWEST</li>
                                    <li>POPULAR</li>
                                    <li>PRICE(HIGH TO LOW)</li>
                                    <li>PRICE(LOW TO HIGH)</li>
                                </ul>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
            
            <div className="properties-list container">
                <div className="row">
                    {propertyList} 
                </div>
            </div>
            
        </div>
    )

}

export default Properties